import GlassCard from './GlassCard'

export default function StatCard({ label, value, subValue, icon, trend, color = 'primary' }) {
  const colorMap = {
    primary: 'text-primary bg-primary-soft',
    secondary: 'text-secondary bg-secondary-soft',
    positive: 'text-positive bg-positive-soft',
    negative: 'text-negative bg-negative-soft',
    warning: 'text-warn bg-warning-soft',
  }

  const trendColorMap = {
    up: 'text-positive',
    down: 'text-negative',
    neutral: 'text-muted',
  }

  return (
    <GlassCard hover className="relative overflow-hidden">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <p className="text-xs font-medium text-muted uppercase tracking-wider">{label}</p>
          <p className="text-2xl font-bold text-heading">{value}</p>
          {subValue && (
            <p className={`text-xs font-medium ${trend ? trendColorMap[trend] : 'text-muted'}`}>
              {trend === 'up' && '↑ '}
              {trend === 'down' && '↓ '}
              {subValue}
            </p>
          )}
        </div>
        {icon && (
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-lg ${colorMap[color] || colorMap.primary}`}>
            {icon}
          </div>
        )}
      </div>
    </GlassCard>
  )
}
